import styled from "styled-components";

interface ButtonScheduleProps {
  disable: boolean;
}

export const Input = styled.input`
  display: none;
`;

export const RequiredFields = styled.div`
  font-size: 12px;
  padding-bottom: 4px;
  color: #6C6C80;
`;

export const Span = styled.span`
  margin-top: -4px;
  color: #464646;
`;

export const ContainerImport = styled.div`
  border : 1px solid rgba(0,0,0,0.25);
  border-radius: 4px;
  padding-left: 14px;
  height: 38px;
  background-color: #FFFFFF;
  :hover {
    border-color:#6e6e6e;
  }
`;

export const ContainerBack = styled.div`
  z-index: 2;
  position: absolute;
  top: 49px;
  left: 52px;
  margin-top: 23px;

  @media (max-width: 600px) {
    top: 65px;
  }

  @media (max-width: 418px) {
    top: 77px;
  }
`;

export const ScheduleButton = styled.label<ButtonScheduleProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 64px;
  width: 136px;
  margin: 0 8px 0 8px;
  border: 1px solid  #095aa5;
  border-radius: 12px;
  background: transparent;
  cursor: ${props => props.disable === true ? 'not-allowed' : 'pointer'};
  transition: 5ms;

  span {
    color:#095aa5;
    font-size: 14px;
    font-weight: bold;
    margin-left: 4px;
    transition: 5ms;
  }

  svg {
    color: #095aa5;
    transition: 5ms;
  }

  &:hover {
    background: #095aa5;
    span, svg {
      color: #fff;
    }
  }
`

export const ButtonContainer = styled.div`
  .btn-download {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 64px;
    width: 136px;
    margin: 0 8px 0 8px;
    border: 1px solid  #095aa5;
    border-radius: 12px;
    background: transparent;
    cursor: pointer;
    transition: 5ms;
    text-decoration: none;

    span {
      color:#095aa5;
      font-size: 14px;
      font-weight: bold;
      margin-left: 4px;
      transition: 5ms;
    }

    svg {
      color: #095aa5;
      transition: 5ms;
    }

    &:hover {
      background: #095aa5;
      span, svg {
        color: #fff;
      }
    }
  }
`

export const SchedulleLabel = styled.span`
  font-size: 16px;
`
